const header = [
	{
		'name': "商品",
		'id': 0,
		'isActive': false
	},
	{
		'name': "详情",
		'id': 1,
		'isActive': false
	},
	{
		'name': "记录",
		'id': 2,
		'isActive': false
	}
];


export {
	header,
}
